import React from 'react'
import Tooltip from 'antd/lib/tooltip'
import Card from 'antd/lib/card'
import classes from './ReworkCard.module.less'
import reworkCardIcon from 'Assets/icons/rework-card.svg'

export const ReworkCard: React.FC = () => {
    const tooltipContent = (
        <div className={classes.tooltipContent}>
            <img src={reworkCardIcon} alt="Rework Card" className={classes.tooltipIcon} />
            <div className={classes.tooltipQuestion}>What is a rework task?</div>
            <div className={classes.tooltipAnswer}>
                The task which needs to be redone because the initial responses did not meet the
                required quality standards.
            </div>
        </div>
    )

    return (
        <Tooltip
            title={tooltipContent}
            placement="bottom"
            classNames={{ root: classes.reworkTooltip }}
        >
            <Card className={classes.reworkCard} size="small" data-testid="rework-card">
                <div className={classes.reworkContent}>
                    <span className={classes.reworkLabel}>REWORK TASK</span>
                </div>
            </Card>
        </Tooltip>
    )
}
